import { Button, Input } from '../../../../Theme'

interface QuantitySelectorProps {
  qty: number
  setQty: (qty: number) => void
}

export function QuantitySelector({ qty, setQty }: QuantitySelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value)
    if (!isNaN(value) && value >= 1) {
      setQty(value)
    }
  }

  const handleBlur = () => {
    if (qty < 1) setQty(1)
  }

  return (
    <div className="flex flex-row border-solid border-2 border-border-color">
      <Button
        variant="outline"
        size="icon"
        className="bg-cards-bg w-[35px] h-[42px] xl:w-[45px] xl:h-[42px] text-2xl font-montserrat font-bold rounded-none border-0"
        onClick={() => setQty(Math.max(1, qty - 1))}
        aria-label="Scade cantitatea"
      >
        -
      </Button>
      <Input
        type="number"
        min={1}
        className="!w-[45px] !h-[42px] !px-1 !py-0 !border-x-2 !border-y-0 !text-center !text-2xl !font-montserrat !font-bold !rounded-none !bg-white !leading-normal [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        name="qty"
        value={qty}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-label="Cantitate"
      />
      <Button
        variant="outline"
        size="icon"
        className="bg-cards-bg w-[35px] h-[42px] xl:w-[45px] xl:h-[42px] text-2xl font-montserrat font-bold rounded-none border-0"
        onClick={() => setQty(qty + 1)}
        aria-label="Creste cantitatea"
      >
        +
      </Button>
    </div>
  )
}
